import { cn } from '@/lib/utils';

interface GridProps {
  className?: string;
}

export function Grid({ className }: GridProps) {
  return (
    <div className={cn('absolute inset-0 -z-10 h-full w-full overflow-hidden', className)}>
      <div
        className="absolute inset-0 bg-grid-foreground/[0.05] dark:bg-grid-foreground/[0.1] [mask-image:radial-gradient(ellipse_80%_80%_at_50%_50%,#000_30%,transparent_100%)]"
        style={{
          backgroundImage: `
            linear-gradient(to right, var(--grid-line-color) 1px, transparent 1px),
            linear-gradient(to bottom, var(--grid-line-color) 1px, transparent 1px)
          `,
          backgroundSize: '50px 50px',
          backgroundPosition: '50% 50%', // Perfect center positioning
        }}
      />
    </div>
  );
}
